<template>
  <div class="banner-principal">
    <div class="banner-principal__rate-firts-room" v-if="currentRoom && currentRoom < 2">
      <i class="icon sm rhg-font-icon--rates"></i>
      <span class="banner-principal__text" v-html="translate('rdMultiRoomBannerMaster')"></span>
    </div>
    <div class="banner-principal__rate" v-else>
      <i class="icon sm rhg-font-icon--rates"></i>
      <div class="banner-principal__text-button">
        <span class="banner-principal__text" v-html="rateMealPlanLabel"></span>
        <button
          id="button-banner"
          type="button"
          class="banner-principal__button rhg-btn-link rhg-btn-link--small rhg-btn-link__uppercase rhg-btn-link__bold"
          @click="$emit('update-room', 1)"
        >
          <span class="banner-principal__button-text">
            {{ translate('rdEditInMasterRooms') }}
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RateMealPlanBanner',
  components: {},
  props: {
    mealPlanName: {
      type: String
    },
    rateName: {
      type: String
    },
    currentRoom: {
      type: Number
    }
  },
  computed: {
    rateMealPlanLabel() {
      return `${this.translate('rdMultiRoomBannerOther', undefined, `<span class="font-bold">${this.rateName}</span>`, `<span class="font-bold">${this.mealPlanName}</span>`)}`
    }
  }
}
</script>

<style lang="scss" scoped>
.banner-principal {
  display: flex;
  width: 100%;

  &__rate-firts-room {
    display: flex;
    align-items: center;
    background-color: #dbe3ec;
    padding: 12px;
    border-radius: 8px;
    width: 100%;

    @media (max-width: 992px) {
      margin: 0 12px 8px 12px;
      align-items: start;
    }
  }

  &__rate {
    display: flex;
    align-items: center;
    background-color: #dbe3ec;
    width: 100%;
    padding: 12px;
    border-radius: 8px;

    @media (max-width: 992px) {
      margin: 9px 12px 5px 12px;
      align-items: start;
    }
  }
  &__text-button {
    display: flex;
    width: 100%;

    @media (max-width: 992px) {
      flex-direction: column;
      align-items: flex-start;
    }
  }
  &__text {
    padding-inline: 8px;
    font-size: 14px;
  }
  &__button {
    margin-left: auto;
    color: #c62525;
    font-size: 12px;

    @media (max-width: 992px) {
      margin-left: 0;
      margin-top: 5px;
    }
  }
}
</style>
